export const AIRASIA_WHITE_LOGO = 'https://static.airasia.com/seo/images/others/airasia-move-logo-secondary.png';
